export default "__VITE_ASSET__18c5fecc__"